import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import PipsyForm from "../../helpers/pipsyForm"
import Title from "../general/title"
import axios from "axios"
import settings from "settings"
import { loadingStatus, getPayload } from "../../actions"
import submitData from "../../helpers/submitData"
import * as Yup from "yup"
import { Formik, Field, Form } from "formik"
import Select from "../../components/Select"
import Typeahead from "../../components/Typeahead"
import NumberField from "../../components/NumberField"
import CheckboxGroup from "../../components/CheckboxGroup"
import DateField from "../../components/DateField"
import TextArea from "../../components/TextArea"
import transformOptions from "../../helpers/transformOptions"
import fieldStatus from '../../helpers/fieldStatus'
import contractFields from "../../models/contract"
import occupation from "../../models/occupation"
import ethnicity from "../../models/ethnicity"

class EditSale extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			valid: false,
			fields: contractFields
		}
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		// get the sale data
		var data = this.props.match.params
		var userToken = localStorage.getItem("user")

		axios
			.post(settings.ep + "/getSale", data, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(response => {
				this.setState({ fields: response.data, loading: false }, () => {
					//console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch(error => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	submitClasses = f => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f
		})

		return submitClasses
	}

	realtorFields = (f) => {
		if(f.values.realtor_involved == 'Yes') {
			return (
				<React.Fragment>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor <sup>*</sup>
						</label>
						{f.errors.realtor && f.touched.realtor && <div className="form__message">{f.errors.realtor}</div>}
						<Field name="realtor" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("realtor_office", f)}>
						<label htmlFor="realtor_office">
							Realtor Office <sup>*</sup>
						</label>
						{f.errors.realtor_office &&
							f.touched.realtor_office && (
								<div className="form__message">
									{f.errors.realtor_office}
								</div>
							)}
						<Typeahead
							name="realtor_office"
							className="form__input"
							value={f.values.realtor_office.value}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.realtor_office}
							error={f.errors.realtor_office}
							placeholder={f.values.label_realtorOffice}
							ep="/realtorOfficeTypeahead"
						/>
					</li>
				</React.Fragment>
			)
		}
	}

	validation = () => {
		return Yup.object().shape({
			entry_id: Yup.number("Please choose an address from the list.")
				.positive("Please choose an address from the list.")
				.required(),
			floorplan: Yup.number("Start typing to choose a floorplan from the list.")
				.typeError("Start typing to choose a floorplan from the list.")
				.positive("Start typing to choose a floorplan from the list.")
				.required("Start typing to choose a floorplan from the list."),
			traffic_source: Yup.number().required("Required"),
			sale_type: Yup.string().required("Required"),
			price: Yup.number().required("Required"),
			square_feet: Yup.number().min(500, "Square feet must be at least 500.").required("Required"),
			//employer: Yup.string().required("Required"),
			current_zip: Yup.number()
				.test("current_zip", "Must be exactly 5 characters", (val) => val.toString().length === 5)
				.required("Required"),
			relo: Yup.number().required("Required"),
			realtor_involved: Yup.string().required("Required"),
			realtor_office: Yup.number().when("realtor_involved", {
				is: "Yes",
				then: Yup.number().moreThan(0, "Please choose an office from the list.").required("Required"),
				otherwise: Yup.number().notRequired(),
			}),
			realtor: Yup.string().when("realtor_involved", {
				is: "Yes",
				then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				otherwise: Yup.string().notRequired(),
			}),
			sale_date: Yup.number().typeError("Please enter a date.").required("Required"),
			estimated_closing: Yup.number().typeError("Please enter a date.").required("Required"),
			buyer_last_name: Yup.string()
				.min(2, "Must be longer than 2 characters")
				.nullable(true)
				.required("Required"),
			buyer_first_name: Yup.string()
				.min(2, "Must be longer than 2 characters")
				.nullable(true)
				.required("Required"),
			buyer_phone: Yup.string()
				.min(10, "Phone number must be 10 digits")
				.max(10, "Phone number must be 10 digits")
				.required("Required"),
			buyer_email: Yup.string().email("Invalid email address").required("Required"),
			//occupation: Yup.string().typeError('Please choose an occupation.').required("Required"),
			age_range: Yup.string().typeError("Please choose an age range.").required("Required"),
			children: Yup.number().required("Required"),
			first_time: Yup.number().required("Required"),
		})
	}

	render() {
		if (this.state.loading) {
			return ""
		} else if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			var classNames = require("classnames")
			var closedClass = classNames("form__list form__closings", {
				"form__closings--active": this.state.fields.closed
			})
			return (
				<div>
					<Formik
						initialValues={this.state.fields}
						validationSchema={this.validation}
						validateOnMount={true}
						//isInitialValid={true}
						onSubmit={(values) => {
							this.props.loadingStatus(true)
							submitData("editSale", values).then((data) => {
								this.props.loadingStatus(false)
								this.setState(
									{
										redirect: true,
										redirectPath: data.redirect,
									},
									() => {
										this.props.getPayload()
									}
								)
							})
						}}
						render={(f) => (
							<div className="sales content">
								{console.log(f)}
								<Title title="Sales" />
								<div className="fullCol">
									<h3>Edit Sales</h3>
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("entry_id", f)}>
												<label htmlFor="entry_id">
													Address <sup>*</sup>
												</label>
												{f.errors.entry_id && f.touched.entry_id && (
													<div className="form__message">{f.errors.entry_id}</div>
												)}
												<Typeahead
													name="entry_id"
													className="form__input"
													value={f.values.id}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.entry_id}
													error={f.errors.entry_id}
													placeholder={f.values.address}
													ep="/addressesAvailableToSell"
												/>
											</li>
											<li className={fieldStatus("sale_type", f)}>
												<label htmlFor="sale_type">
													Sale Type <sup>*</sup>
												</label>
												{f.errors.sale_type && f.touched.sale_type && (
													<div className="form__message">{f.errors.sale_type}</div>
												)}
												<Select
													name="sale_type"
													options={[
														{
															value: "Dirt",
															label: "Dirt",
														},
														{
															value: "Spec",
															label: "Spec",
														},
													]}
													className="form__input"
													value={f.values.sale_type}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sale_type}
													error={f.errors.sale_type}
												/>
											</li>
											<li className={fieldStatus("square_feet", f)}>
												<label htmlFor="square_feet">
													Square Feet <sup>*</sup>
												</label>
												{f.errors.sqft && f.touched.sqft && (
													<div className="form__message">{f.errors.sqft}</div>
												)}
												<NumberField
													name="sqft"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sqft}
													error={f.errors.sqft}
													value={f.values.sqft}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("floorplan", f)}>
												<label htmlFor="floorplan">
													Floorplan <sup>*</sup>
												</label>
												{f.errors.floorplan && f.touched.floorplan && (
													<div className="form__message">{f.errors.floorplan}</div>
												)}
												<Typeahead
													name="floorplan"
													className="form__input"
													value={f.values.floorplan}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.floorplan}
													error={f.errors.floorplan}
													placeholder={f.values.label_floorplan}
													ep="/typeaheadFloorplans"
													extra={{ property: this.state.fields.property }}
												/>
											</li>
											<li className={fieldStatus("price", f)}>
												<label htmlFor="price">
													Sale Price <sup>*</sup>
												</label>
												{f.errors.price && f.touched.price && (
													<div className="form__message">{f.errors.price}</div>
												)}
												<NumberField
													name="price"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.price}
													error={f.errors.price}
													value={f.values.price}
													thousandSeparator={true}
													prefix="$"
												/>
											</li>
											<li className={fieldStatus("sale_date", f)}>
												<label htmlFor="sale_date">
													Sale Date <sup>*</sup>
												</label>
												{f.errors.sale_date && f.touched.sale_date && (
													<div className="form__message">{f.errors.sale_date}</div>
												)}
												<DateField
													name="sale_date"
													className="form__textarea"
													value={f.values.sale_date}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.sale_date}
													error={f.errors.sale_date}
												/>
											</li>
											<li className={fieldStatus("estimated_closing", f)}>
												<label htmlFor="estimated_closing">
													Estimated Closing <sup>*</sup>
												</label>
												{f.errors.estimated_closing && f.touched.estimated_closing && (
													<div className="form__message">{f.errors.estimated_closing}</div>
												)}
												<DateField
													name="estimated_closing"
													className="form__textarea"
													value={f.values.estimated_closing}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.estimated_closing}
													error={f.errors.estimated_closing}
												/>
											</li>
											<li className={fieldStatus("traffic_source", f)}>
												<label htmlFor="traffic_source">
													Traffic Source <sup>*</sup>
												</label>
												{f.errors.traffic_source && f.touched.traffic_source && (
													<div className="form__message">{f.errors.traffic_source}</div>
												)}
												<Select
													name="traffic_source"
													options={_.map(this.props.payload.public.trafficSources, (v) => {
														return { value: v.id, label: v.name }
													})}
													className="form__input"
													value={f.values.traffic_source}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.traffic_source}
													error={f.errors.traffic_source}
												/>
											</li>
											<li className={fieldStatus("event_id", f)}>
												<label htmlFor="event_id">Event</label>
												{f.errors.event_id && f.touched.event_id && (
													<div className="form__message">{f.errors.event_id}</div>
												)}
												<Typeahead
													name="event_id"
													className="form__input"
													value={f.values.event_id}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.event_id}
													error={f.errors.event_id}
													placeholder={f.values.label_event}
													ep="/typeaheadEvents"
												/>
											</li>
											<li className={fieldStatus("realtor_involved", f)}>
												<label htmlFor="realtor_involved">
													Realtor Involved? <sup>*</sup>
												</label>
												{f.errors.realtor_involved && f.touched.realtor_involved && (
													<div className="form__message">{f.errors.realtor_involved}</div>
												)}
												<Select
													name="realtor_involved"
													options={[
														{
															value: 0,
															label: "No",
														},
														{
															value: 1,
															label: "Yes",
														},
														{
															value: 2,
															label: "Yes - Unknown",
														},
													]}
													className="form__input"
													value={f.values.realtor_involved}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.realtor_involved}
													error={f.errors.realtor_involved}
												/>
											</li>
											{this.realtorFields(f)}
											<li className={fieldStatus("buyer_first_name", f)}>
												<label htmlFor="buyer_first_name">
													Buyer First Name<sup>*</sup>
												</label>
												{f.errors.buyer_first_name && f.touched.buyer_first_name && (
													<div className="form__message">{f.errors.buyer_first_name}</div>
												)}
												<Field name="buyer_first_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("buyer_last_name", f)}>
												<label htmlFor="buyer_last_name">
													Buyer Last Name<sup>*</sup>
												</label>
												{f.errors.buyer_last_name && f.touched.buyer_last_name && (
													<div className="form__message">{f.errors.buyer_last_name}</div>
												)}
												<Field name="buyer_last_name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("zip", f)}>
												<label htmlFor="zip">
													Current Zip <sup>*</sup>
												</label>
												{f.errors.zip && f.touched.zip && (
													<div className="form__message">{f.errors.zip}</div>
												)}
												<Field name="zip" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("buyer_phone", f)}>
												<label htmlFor="buyer_phone">
													Buyer Phone <sup>*</sup>
												</label>
												{f.errors.buyer_phone && f.touched.buyer_phone && (
													<div className="form__message">{f.errors.buyer_phone}</div>
												)}
												<NumberField
													name="buyer_phone"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.buyer_phone}
													error={f.errors.buyer_phone}
													value={f.values.buyer_phone}
													//thousandSeparator={true}
													format="+1 (###) ###-####"
												/>
											</li>
											<li className={fieldStatus("buyer_email", f)}>
												<label htmlFor="buyer_email">
													Buyer Email <sup>*</sup>
												</label>
												{f.errors.buyer_email && f.touched.buyer_email && (
													<div className="form__message">{f.errors.buyer_email}</div>
												)}
												<Field name="buyer_email" type="email" className="form__input" />
											</li>
											<li className={fieldStatus("age_range", f)}>
												<label htmlFor="age_range">Age Range</label>
												{f.errors.age_range && f.touched.age_range && (
													<div className="form__message">{f.errors.age_range}</div>
												)}
												<Select
													name="age_range"
													options={[
														{
															value: "18 - 24",
															label: "18 - 24",
														},
														{
															value: "25 - 34",
															label: "25 - 34",
														},
														{
															value: "35 - 44",
															label: "35 - 44",
														},
														{
															value: "45 - 54",
															label: "45 - 54",
														},
														{
															value: "55 - 64",
															label: "55 - 64",
														},
														{
															value: "65+",
															label: "65+",
														},
													]}
													className="form__input"
													value={f.values.age_range}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.age_range}
													error={f.errors.age_range}
												/>
											</li>
											<li className={fieldStatus("employer", f)}>
												<label htmlFor="employer">Employer</label>
												{f.errors.employer && f.touched.employer && (
													<div className="form__message">{f.errors.employer}</div>
												)}
												<Field name="employer" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("children_ages", f)}>
												<label htmlFor="children_ages">Ages of Children</label>
												{f.errors.children_ages && f.touched.children_ages && (
													<div className="form__message">{f.errors.children_ages}</div>
												)}
												<CheckboxGroup
													name="children_ages"
													options={[
														{
															value: "0-4",
															label: "0-4",
														},
														{
															value: "5-10",
															label: "5-10",
														},
														{
															value: "11-15",
															label: "11-15",
														},
														{
															value: "16-18",
															label: "16-18",
														},
														{
															value: "Empty Nesters",
															label: "Empty Nesters",
														},
													]}
													className="form__input"
													value={f.values.children_ages}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.children_ages}
													error={f.errors.children_ages}
												/>
											</li>
											<li className={fieldStatus("ethnicity", f)}>
												<label htmlFor="ethnicity">Ethnicity</label>
												{f.errors.ethnicity && f.touched.ethnicity && (
													<div className="form__message">{f.errors.ethnicity}</div>
												)}
												<Select
													name="ethnicity"
													options={ethnicity}
													className="form__input"
													value={f.values.ethnicity}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.ethnicity}
													error={f.errors.ethnicity}
												/>
											</li>
											<li className={fieldStatus("first_time", f)}>
												<label htmlFor="first_time">
													First Time? <sup>*</sup>
												</label>
												{f.errors.first_time && f.touched.first_time && (
													<div className="form__message">{f.errors.first_time}</div>
												)}
												<Select
													name="first_time"
													options={[
														{
															value: "0",
															label: "No",
														},
														{
															value: "1",
															label: "Yes",
														},
													]}
													className="form__input"
													value={f.values.first_time}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.first_time}
													error={f.errors.first_time}
												/>
											</li>
											<li className={fieldStatus("comments", f)}>
												<label htmlFor="comments">Comments/Notes</label>
												{f.errors.comments && f.touched.comments && (
													<div className="form__message">{f.errors.comments}</div>
												)}
												<TextArea
													name="comments"
													className="form__textarea"
													value={f.values.comments}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.comments}
													error={f.errors.comments}
												/>
											</li>
										</ul>
										<ul className={closedClass}>
											<li className="form__title">
												<h2>Closing Info</h2>
											</li>
											<li className={fieldStatus("closing_price", f)}>
												<label htmlFor="closing_price">
													Closing Price <sup>*</sup>
												</label>
												{f.errors.closing_price && f.touched.closing_price && (
													<div className="form__message">{f.errors.closing_price}</div>
												)}
												<NumberField
													name="closing_price"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.closing_price}
													error={f.errors.closing_price}
													value={f.values.closing_price}
													thousandSeparator={true}
													prefix="$"
												/>
											</li>
											<li className={fieldStatus("closing_square_feet", f)}>
												<label htmlFor="closing_square_feet">
													Closing Square Feet <sup>*</sup>
												</label>
												{f.errors.closing_square_feet && f.touched.closing_square_feet && (
													<div className="form__message">{f.errors.closing_square_feet}</div>
												)}
												<NumberField
													name="closing_square_feet"
													type="text"
													className="form__input"
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.closing_square_feet}
													error={f.errors.closing_square_feet}
													value={f.values.closing_square_feet}
													thousandSeparator={true}
												/>
											</li>
											<li className={fieldStatus("closing_date", f)}>
												<label htmlFor="closing_date">
													Closing Date <sup>*</sup>
												</label>
												{f.errors.closing_date && f.touched.closing_date && (
													<div className="form__message">{f.errors.closing_date}</div>
												)}
												<DateField
													name="closing_date"
													className="form__textarea"
													value={f.values.closing_date}
													onChange={f.setFieldValue}
													onBlur={f.setFieldTouched}
													touched={f.touched.closing_date}
													error={f.errors.closing_date}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							</div>
						)}
					/>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus: loadingStatus,
			getPayload
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditSale)
